import { useContext, useEffect, useState } from "react";
import { Col, Collapse, Input, Row, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import CommonFilter from "../../common/CommonFilter";
import { saveAdvancedSelectedFilters } from "../../actionCreator/leadListingActionCreater";
import {
  Clock,
  User,
  Globe,
  Map,
  MapPin,
  Hash,
  FileText,
  Tag,
  Building2,
  Factory,
  Users,
  Briefcase,
  Star,
  Layers,
  ClipboardList,
  UserCheck,
  Contact,
  Info,
  Tags,
  Search,
  ChevronUp,
  ChevronDown,
} from "lucide-react";
import { AuthContext } from "../../context/AuthContext";
import { userRoles } from "../../config";

const AdvancedFilter = ({
  isModal,
  openAdvancedModel,
  showCheckAll = true,
  setOpenAdvancedModel,
  showNumberofRecords = null,
}) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const companyFilterList = useSelector((state) => state.leadListingReducer);
  const companySelectedFilterList = useSelector(
    (state) => state.leadListingReducer.selectedFilters,
  );

  const companyFilterListIndustry = useSelector(
    (state) => state.leadListingReducer.industryList,
  );

  const companyFilterListEmployeeCountList = useSelector(
    (state) => state.leadListingReducer.employeeCountList,
  );

  const companyFilterListCities = useSelector(
    (state) => state.leadListingReducer.geoLocation?.cities,
  );
  const companyFilterListCountries = useSelector(
    (state) => state.leadListingReducer.geoLocation?.countries,
  );
  const companyFilterListStates = useSelector(
    (state) => state.leadListingReducer.geoLocation?.states,
  );
  const currentUserPermissions = useSelector(
    (state) => state.UserManagementReducer.currentUserPermissions,
  );
  const users = useSelector((state) => state.UserManagementReducer.users);

  const leadFilterStatusList = useSelector(
    (state) => state.leadListingReducer.leadStatusList,
  );

  const leadFilterRatingList = useSelector(
    (state) => state.leadListingReducer.leadRatingList,
  );
  const tags = useSelector((state) => state.leadListingReducer?.companyTagList);
  const notesTags = useSelector((state) => state.LeadDetailsReducer?.notesTags);

  const [visibleFilter, setVisibleFilter] = useState({
    country: false,
    state: false,
    city: false,
    industry: false,
    companyType: false,
    employeeCount: false,
    revenue: false,
    savedSearch: false,
    companyTag: false,
    executiveFunction: false,
    executiveLevel: false,
    leadTimeRange: false,
    leadRating: false,
    leadStatus: false,
    leadSource: false,
  });
  const [selectedCountryList, setSelectedCountryList] = useState([]);
  const [selectedStateList, setSelectedStateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [leadStatusList, setLeadStatusList] = useState([]);
  const [leadRatingList, setLeadRatingList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [active, setActive] = useState(isModal ? ["lead-details"] : []);

  useEffect(() => {
    const allParams = {};
    for (const [key, value] of searchParams.entries()) {
      allParams[key] = value;
    }
    dispatch(
      saveAdvancedSelectedFilters({
        selectedExecutiveFunction: allParams?.["Executive Function"],
        selectedExecutiveLevel: allParams?.["Executive Level"],
        selectedCountry: allParams?.Countries?.split(","),
        selectedState: allParams?.States?.split(","),
        selectedCity: allParams?.Cities?.split(","),
        selectedIndustry: allParams?.Industry?.split(","),
        selectedCompanytype: allParams?.["Company Type"]?.split(","),
        selectedEmployeecount: allParams?.["Employee Count"]?.split(","),
        selectedRevenuerange: allParams?.["Revenue Range"]?.split(","),
        searchKeyword: allParams?.searchKeyword,
        selectedCompanyTag: allParams?.Tags?.split(","),
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (!selectedStateList?.length) {
      setCitiesList(
        selectedCountryList?.length
          ? companyFilterList?.geoLocation?.cities.filter((city) => {
              return selectedCountryList
                ?.map((d) => ({
                  ...companyFilterList?.geoLocation?.countries?.find(
                    (i) => i?.name === d,
                  ),
                }))
                ?.some((ct) => {
                  return ct?.country_id === city?.country_id;
                });
            })
          : companyFilterList?.geoLocation?.cities,
      );
    } else {
      const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
        return selectedStateList
          ?.map((d) => ({
            ...companyFilterList?.geoLocation?.states?.find(
              (i) => i?.name === d,
            ),
          }))
          ?.some((ct) => {
            return (
              ct.state_id === city?.state_id &&
              ct?.country_id === city?.country_id
            );
          });
      });
      setCitiesList(cityList);
    }
  }, [selectedStateList]);

  useEffect(() => {
    if (!selectedCountryList?.length) {
      setStatesList(companyFilterList?.geoLocation?.states);
    } else {
      //By Nawedita
      const cityList = companyFilterList?.geoLocation?.states.filter((city) => {
        return selectedCountryList
          ?.map((d) => ({
            ...companyFilterList?.geoLocation?.countries?.find(
              (i) => i?.name === d,
            ),
          }))
          ?.some((ct) => {
            return ct.country_id === city?.country_id;
          });
      });
      setStatesList(cityList);
    }
  }, [selectedCountryList]);

  useEffect(() => {
    setLeadRatingList(leadFilterRatingList);
    setLeadStatusList(leadFilterStatusList);
    setCitiesList(companyFilterListCities);
  }, [companyFilterListCities, leadFilterRatingList, leadFilterStatusList]);

  useEffect(() => {
    setSelectedCountryList(companySelectedFilterList?.selectedCountry);
    setSelectedStateList(companySelectedFilterList?.selectedState);
  }, [companySelectedFilterList]);

  const openVisibleFilter = (menu) => {
    setVisibleFilter({
      ...{
        country: false,
        state: false,
        city: false,
        industry: false,
        companyType: false,
        employeeCount: false,
        revenue: false,
        utility: false,
        pages: false,
        savedSearch: false,
        companyTag: false,
        executiveFunction: false,
        executiveLevel: false,
        leadOwner: false,
        firstName: false,
        lastName: false,
        zipCode: false,
        leadStatus: false,
        leadSource: false,
        notesTags: false,
      },
      [menu]: !visibleFilter[menu],
    });
  };

  const onCountriesChange = (list) => {
    updateStateBasedOnCountry(list);
  };

  const updateStateBasedOnCountry = (list) => {
    const stateList = companyFilterList?.geoLocation?.states.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return ct.country_id === city?.country_id;
          })
        : companyFilterList?.geoLocation?.states;
    });

    setStatesList(stateList);

    const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return ct?.country_id === city?.country_id;
          })
        : companyFilterList?.geoLocation?.cities;
    });
    setCitiesList(cityList);
  };

  const filterCountry = (ele) => {
    setSelectedCountryList([]);
  };

  /*Countries Start */
  const showCountriesList = () => {
    return (
      <CommonFilter
        isModal={isModal}
        title="Countries"
        icon={<Globe size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListCountries}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        onDataChange={onCountriesChange}
        onSearch={filterCountry}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("country")}
        isShow={visibleFilter.country}
      />
    );
  };

  /*Countries End */

  /*State Start */
  const showStatesList = () => {
    return (
      <CommonFilter
        title="States"
        isModal={isModal}
        icon={<Map size={16} className="tw-text-slate-500" />}
        dataList={statesList}
        onSearch={filterState}
        onDataChange={onStatesChange}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("state")}
        isShow={visibleFilter.state}
      />
    );
  };

  const filterState = (ele) => {
    setSelectedStateList([]);
  };

  const onStatesChange = (list) => {
    updateCityBasedOnState(list);
  };

  const updateCityBasedOnState = (list) => {
    const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return (
              ct.state_id === city?.state_id &&
              ct?.country_id === city?.country_id
            );
          })
        : companyFilterList?.geoLocation?.cities;
    });

    setCitiesList(cityList);
  };

  /*state End */

  /* City Start */
  const showCitiesList = () => {
    return (
      <CommonFilter
        title="Cities"
        isModal={isModal}
        icon={<MapPin size={16} className="tw-text-slate-500" />}
        dataList={citiesList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("city")}
        isShow={visibleFilter.city}
      />
    );
  };

  /*City End */

  /*Industry Start */
  const showIndustryList = () => {
    return (
      <>
        <CommonFilter
          title="Industry"
          isModal={isModal}
          icon={<Factory size={16} className="tw-text-slate-500" />}
          dataList={companyFilterListIndustry}
          showNumberofRecords={showNumberofRecords}
          showCheckAll={showCheckAll}
          setOpenAdvancedModel={setOpenAdvancedModel}
          openVisibleFilter={() => openVisibleFilter("industry")}
          isShow={visibleFilter.industry}
        />
      </>
    );
  };

  /*Industry End */

  /*Lead Rating Start */
  const showLeadRatingList = () => {
    return (
      <CommonFilter
        title="Lead Rating"
        isModal={isModal}
        icon={<Star size={16} className="tw-text-slate-500" />}
        dataList={leadRatingList?.map((d) => ({ ...d, name: d?.ratingText }))}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("leadRating")}
        isShow={visibleFilter.leadRating}
      />
    );
  };

  /*Lead Rating End */

  /*Lead Time Start */
  const showLeadTimeList = () => {
    return (
      <CommonFilter
        title="Lead Time"
        isModal={isModal}
        icon={<Clock size={16} className="tw-text-slate-500" />}
        dataList={[
          { name: "Today" },
          { name: "Yesterday" },
          { name: "This Month" },
          { name: "This Year" },
          { name: "Last 7 days" },
        ]}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("leadTime")}
        isShow={visibleFilter.leadTime}
      />
    );
  };

  /*Lead Time End */

  //start lead status list
  const showLeadStatus = () => {
    return (
      <CommonFilter
        title="Lead Status"
        isModal={isModal}
        icon={<Layers size={16} className="tw-text-slate-500" />}
        dataList={leadStatusList?.map((d) => ({ ...d, name: d?.text }))}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("leadStatus")}
        isShow={visibleFilter.leadStatus}
      />
    );
  };

  //end lead status list

  //start lead Owner filter
  const showInputSearch = (visibleFilter, type, title, iconClass) => {
    return (
      <>
        <div
          className={`filterheader la ${visibleFilter[type] && "show"}`}
          onClick={() => openVisibleFilter(type)}
        >
          {!isModal && (
            <h2
              className={`side-filter ${!isModal && "tw-bg-[#fafafa]"} tw-flex tw-items-center tw-justify-between !tw-px-4`}
            >
              <div className="tw-flex tw-items-center tw-gap-2">
                {typeof iconClass === "string" ? (
                  <i className={`left-company-menu-icons las ${iconClass}`}></i>
                ) : (
                  iconClass
                )}
                <span className="tw-font-inter">{title}</span>
              </div>
              <div>
                {visibleFilter[type] ? (
                  <ChevronUp size={16} className="tw-text-slate-500" />
                ) : (
                  <ChevronDown size={16} className="tw-text-slate-500" />
                )}
              </div>
            </h2>
          )}
        </div>
        {type !== "leadOwner" && (
          <div className="filteroptions">
            <div className={isModal ? "" : "searchbox tw-font-inter"}>
              <Input
                value={searchParams.get(type)}
                placeholder="Search"
                className={
                  isModal
                    ? "tw-bg-secondary-color tw-border-secondary-color"
                    : ""
                }
                prefix={
                  <Search
                    size={16}
                    className={isModal ? "tw-text-slate-400" : "tw-text-slate-400"}
                  />
                }
                onChange={(e) => filterInputSearch(e, type)}
              />
            </div>
          </div>
        )}
        {type === "leadOwner" && visibleFilter?.leadOwner && (
          <div className="tw-mx-3 tw-mt-1">
            <Select
              value={
                searchParams.get("ownerName")
                  ? users?.content?.find(
                      (user) =>
                        user?.id === parseInt(searchParams.get("ownerName")),
                    )?.firstName +
                    " " +
                    users?.content?.find(
                      (user) =>
                        user?.id === parseInt(searchParams.get("ownerName")),
                    )?.lastName
                  : null
              }
              placeholder="Select New Owner"
              className={`${isModal ? "tw-custom-select tw-w-full" : "tw-w-full"}`}
              notFoundContent={
                <span className="tw-text-xs tw-text-sub-text">
                  You do not have any internal users. Please create users to use
                  this feature.
                </span>
              }
              allowClear
              onChange={(val) => {
                onFilterChange("ownerName", val);
                onFilterChange("page", 1);
              }}
            >
              {user?.role === userRoles?.admin ? (
                <>
                  {(users?.content || []).map((user) => (
                    <Select.Option key={user?.id} value={user?.id}>
                      {user.firstName} {user.lastName}
                    </Select.Option>
                  ))}
                </>
              ) : (
                <>
                  {(
                    [
                      ...(currentUserPermissions || []),
                      {
                        ...users?.content?.find((d) => d?.id === user?.id),
                        targetUser: users?.content?.find(
                          (d) => d?.id === user?.id,
                        ),
                        permission: {
                          createdDate: null,
                          id: 1,
                          internalName: "view",
                          lastModifiedDate: null,
                          name: "View",
                        },
                      },
                    ] || []
                  )
                    ?.filter((d) => d?.permission?.name === "View")
                    .map((user) => (
                      <Select.Option
                        key={user?.targetUser?.id}
                        value={user?.targetUser?.id}
                      >
                        {user?.targetUser?.firstName}{" "}
                        {user?.targetUser?.lastName}
                      </Select.Option>
                    ))}
                </>
              )}
            </Select>
          </div>
        )}
      </>
    );
  };

  const onFilterChange = (key, val) => {
    if (val !== undefined) {
      searchParams.set(key, val);
    } else {
      searchParams.delete(key);
    }
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };
  const filterInputSearch = (event, type) => {
    onFilterChange(
      type,
      event?.target?.value ? event?.target?.value : undefined,
    );
    onFilterChange("page", 1);
  };

  /*start employee count */
  const showEmployeeCountList = () => {
    return (
      <CommonFilter
        title="Employee Size"
        isModal={isModal}
        icon={<Users size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListEmployeeCountList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("employeeCount")}
        isShow={visibleFilter.employeeCount}
      />
    );
  };

  /*End employee count */

  /*Start Company Tag List */
  const showLeadTagList = () => {
    return (
      <CommonFilter
        title="Tags"
        isModal={isModal}
        icon={<Tag size={16} className="tw-text-slate-500" />}
        dataList={tags}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("companyTag")}
        isShow={visibleFilter.companyTag}
      />
    );
  };

  /*End Company Tags List */

  /*Start Notes Tag List */
  const showNoteTagList = () => {
    return (
      <CommonFilter
        title="Notes Tags"
        isModal={isModal}
        icon={<FileText size={16} className="tw-text-slate-500" />}
        dataList={notesTags}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("notesTags")}
        isShow={visibleFilter.notesTags}
      />
    );
  };

  /*End Notes Tags List */

  const renderJsx = () => {
    if (openAdvancedModel.key === "Industry") {
      return (
        <div className="filterblk" id="industry">
          {showIndustryList()}
        </div>
      );
    } else if (openAdvancedModel.key === "Countries") {
      return (
        <div className="filterblk" id="county">
          {showCountriesList()}
        </div>
      );
    } else if (openAdvancedModel.key === "States") {
      return (
        <div className="filterblk" id="state">
          {showStatesList()}
        </div>
      );
    } else if (openAdvancedModel.key === "Cities") {
      return (
        <div className="filterblk" id="city">
          {showCitiesList()}
        </div>
      );
    } else if (openAdvancedModel.key === "Employee Size") {
      return (
        <div className="filterblk" id="emplyeeCount">
          {showEmployeeCountList()}
        </div>
      );
    } else if (openAdvancedModel.key === "Lead Status") {
      return (
        <div className="filterblk" id="emplyeeCount">
          {showLeadStatus()}
        </div>
      );
    } else {
      return (
        <>
          {isModal ? (
            <Row className="tw-bg-white tw-border-t tw-border-b tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-slate-100">
              <Col
                xs={8}
                className="tw-p-4 tw-flex tw-flex-col tw-gap-2 tw-bg-slate-50/50 tw-border-t-0 tw-border-b-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-slate-100 tw-font-inter"
              >
                <div className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400 tw-mb-2">
                  Filter Categories
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("lead-details") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["lead-details"]);
                  }}
                >
                  <ClipboardList size={16} className={active?.includes("lead-details") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Lead Details
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("contact-info") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["contact-info"]);
                  }}
                >
                  <Contact size={16} className={active?.includes("contact-info") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Contact Information
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("company-info") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["company-info"]);
                  }}
                >
                  <Info size={16} className={active?.includes("company-info") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Company Information
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("location") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["location"]);
                  }}
                >
                  <MapPin size={16} className={active?.includes("location") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Location
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("classification") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["classification"]);
                  }}
                >
                  <Tags size={16} className={active?.includes("classification") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Classification
                </div>
              </Col>
              <Col
                xs={16}
                className="tw-p-4 tw-max-h-[400px] tw-overflow-y-auto"
              >
                {active?.includes("classification") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "classification",
                          label: (
                            <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Tags
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk">
                                {" "}
                                <div className="filterblk" id="zipCode">
                                  {showLeadTagList(
                                    visibleFilter,
                                    "tags",
                                    "Tags",
                                    <Tag size={16} className="tw-text-slate-500" />,
                                  )}
                                </div>
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "classification",
                          label: (
                            <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Notes Tags
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk">
                                <div className="filterblk" id="notesTags">
                                  {showNoteTagList(
                                    visibleFilter,
                                    "tags",
                                    "Notes Tags",
                                    <FileText size={16} className="tw-text-slate-500" />,
                                  )}
                                </div>
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                ) : active?.includes("location") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "location",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Countries
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="county">
                                {showCountriesList()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "location",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              States
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="state">
                                {showStatesList()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "location",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Cities
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="city">
                                {showCitiesList()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "location",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Zip Code
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="zipCode">
                                {showInputSearch(
                                  visibleFilter,
                                  "zipCode",
                                  "Zip Code",
                                  <Hash size={16} className="tw-text-slate-500" />,
                                )}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                ) : active?.includes("company-info") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Company Name
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="companyName">
                                {showInputSearch(
                                  visibleFilter,
                                  "companyName",
                                  "Company Name",
                                  <Building2 size={16} className="tw-text-slate-500" />,
                                )}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Employee Size
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="emplyeeCount">
                                {showEmployeeCountList()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Industry
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="industry">
                                {showIndustryList()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                ) : active?.includes("contact-info") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              First Name
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="firstName">
                                {showInputSearch(
                                  visibleFilter,
                                  "firstName",
                                  "First Name",
                                  <User size={16} className="tw-text-slate-500" />,
                                )}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Last Name
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="lastName">
                                {showInputSearch(
                                  visibleFilter,
                                  "lastName",
                                  "Last Name",
                                  <User size={16} className="tw-text-slate-500" />,
                                )}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Designation
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="designation">
                                {showInputSearch(
                                  visibleFilter,
                                  "designation",
                                  "Designation",
                                  <Briefcase size={16} className="tw-text-slate-500" />,
                                )}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                ) : (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Lead Time
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="leadTimeRange">
                                {showLeadTimeList()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Lead Owner
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="leadOwner">
                                {showInputSearch(
                                  visibleFilter,
                                  "leadOwner",
                                  "Lead Owner",
                                  <User size={16} className="tw-text-slate-500" />,
                                )}
                                <div className="tw-mx-3 tw-mt-1">
                                  <Select
                                    value={
                                      searchParams.get("ownerName")
                                        ? users?.content?.find(
                                            (user) =>
                                              user?.id ===
                                              parseInt(
                                                searchParams.get("ownerName"),
                                              ),
                                          )?.firstName +
                                          " " +
                                          users?.content?.find(
                                            (user) =>
                                              user?.id ===
                                              parseInt(
                                                searchParams.get("ownerName"),
                                              ),
                                          )?.lastName
                                        : null
                                    }
                                    placeholder="Select New Owner"
                                    className={`${isModal ? "tw-custom-select tw-w-full" : "tw-w-full"}`}
                                    notFoundContent={
                                      <span className="tw-text-xs tw-text-sub-text">
                                        You do not have any internal users.
                                        Please create users to use this feature.
                                      </span>
                                    }
                                    allowClear
                                    onChange={(val) => {
                                      onFilterChange("ownerName", val);
                                      onFilterChange("page", 1);
                                    }}
                                  >
                                    {user?.role === userRoles?.admin ? (
                                      <>
                                        {(users?.content || []).map((user) => (
                                          <Select.Option
                                            key={user?.id}
                                            value={user?.id}
                                          >
                                            {user.firstName} {user.lastName}
                                          </Select.Option>
                                        ))}
                                      </>
                                    ) : (
                                      <>
                                        {(
                                          [
                                            ...(currentUserPermissions || []),
                                            {
                                              ...users?.content?.find(
                                                (d) => d?.id === user?.id,
                                              ),
                                              targetUser: users?.content?.find(
                                                (d) => d?.id === user?.id,
                                              ),
                                              permission: {
                                                createdDate: null,
                                                id: 1,
                                                internalName: "view",
                                                lastModifiedDate: null,
                                                name: "View",
                                              },
                                            },
                                          ] || []
                                        )
                                          ?.filter(
                                            (d) =>
                                              d?.permission?.name === "View",
                                          )
                                          .map((user) => (
                                            <Select.Option
                                              key={user?.targetUser?.id}
                                              value={user?.targetUser?.id}
                                            >
                                              {user?.targetUser?.firstName}{" "}
                                              {user?.targetUser?.lastName}
                                            </Select.Option>
                                          ))}
                                      </>
                                    )}
                                  </Select>
                                </div>
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Lead Rating
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="rating">
                                {showLeadRatingList()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Lead Status
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="leadStatus">
                                {showLeadStatus()}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                    <Collapse
                      className="tw-advanced-filter"
                      expandIcon={({ isActive }) =>
                        isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                      }
                      expandIconPosition="end"
                      items={[
                        {
                          key: "company-info",
                          label: (
                            <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                              Lead Source
                            </div>
                          ),
                          children: (
                            <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                              <div className="filterblk" id="leadSource">
                                {showInputSearch(
                                  visibleFilter,
                                  "leadSource",
                                  "Lead Source",
                                  <Search size={16} className="tw-text-slate-500" />,
                                )}
                              </div>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </div>
                )}
              </Col>
            </Row>
          ) : (
            <div className="tw-text-text-primary tw-p-1 tw-flex tw-flex-col tw-gap-2">
              <Collapse
                defaultActiveKey={active}
                onChange={(val) => {
                  setActive(
                    !val?.length
                      ? [...active?.filter((d) => d !== "lead-details")]
                      : [...active, val[0]],
                  );
                }}
                className={`${active?.includes("lead-details") ? "tw-filter-collapse" : ""} tw-text-text-primary`}
                ghost={!active?.includes("lead-details")}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <ChevronUp size={16} className="tw-text-slate-500" />
                  ) : (
                    <ChevronDown size={16} className="tw-text-slate-500" />
                  )
                }
                expandIconPosition="end"
                items={[
                  {
                    key: "lead-details",
                    label: (
                      <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                        <ClipboardList size={16} className="tw-text-slate-500" />
                        Lead Details
                      </div>
                    ),
                    children: (
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                        <div className="filterblk" id="leadTimeRange">
                          {showLeadTimeList()}
                        </div>
                        <div className="filterblk" id="leadOwner">
                          {showInputSearch(
                            visibleFilter,
                            "leadOwner",
                            "Lead Owner",
                            <User size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                        <div className="filterblk" id="rating">
                          {showLeadRatingList()}
                        </div>
                        <div className="filterblk" id="leadStatus">
                          {showLeadStatus()}
                        </div>
                        <div className="filterblk" id="leadSource">
                          {showInputSearch(
                            visibleFilter,
                            "leadSource",
                            "Lead Source",
                            <Search size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
              <Collapse
                defaultActiveKey={active}
                onChange={(val) => {
                  setActive(
                    !val?.length
                      ? [...active?.filter((d) => d !== "contact-info")]
                      : [...active, val[0]],
                  );
                }}
                className={
                  active?.includes("contact-info") ? "tw-filter-collapse" : ""
                }
                ghost={!active?.includes("contact-info")}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <ChevronUp size={16} className="tw-text-slate-500" />
                  ) : (
                    <ChevronDown size={16} className="tw-text-slate-500" />
                  )
                }
                expandIconPosition="end"
                items={[
                  {
                    key: "contact-info",
                    label: (
                      <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                        <UserCheck size={16} className="tw-text-slate-500" />
                        Contact Information
                      </div>
                    ),
                    children: (
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                        <div className="filterblk" id="firstName">
                          {showInputSearch(
                            visibleFilter,
                            "firstName",
                            "First Name",
                            <User size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                        <div className="filterblk" id="lastName">
                          {showInputSearch(
                            visibleFilter,
                            "lastName",
                            "Last Name",
                            <User size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                        <div className="filterblk" id="designation">
                          {showInputSearch(
                            visibleFilter,
                            "designation",
                            "Designation",
                            <Briefcase size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
              <Collapse
                defaultActiveKey={active}
                onChange={(val) => {
                  setActive(
                    !val?.length
                      ? [...active?.filter((d) => d !== "company-info")]
                      : [...active, val[0]],
                  );
                }}
                className={
                  active?.includes("company-info") ? "tw-filter-collapse" : ""
                }
                ghost={!active?.includes("company-info")}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <ChevronUp size={16} className="tw-text-slate-500" />
                  ) : (
                    <ChevronDown size={16} className="tw-text-slate-500" />
                  )
                }
                expandIconPosition="end"
                items={[
                  {
                    key: "company-info",
                    label: (
                      <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                        <Building2 size={16} className="tw-text-slate-500" />
                        Company Information
                      </div>
                    ),
                    children: (
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                        <div className="filterblk" id="companyName">
                          {showInputSearch(
                            visibleFilter,
                            "companyName",
                            "Company Name",
                            <Building2 size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                        <div className="filterblk" id="emplyeeCount">
                          {showEmployeeCountList()}
                        </div>
                        <div className="filterblk" id="industry">
                          {showIndustryList()}
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
              <Collapse
                defaultActiveKey={active}
                onChange={(val) => {
                  setActive(
                    !val?.length
                      ? [...active?.filter((d) => d !== "location")]
                      : [...active, val[0]],
                  );
                }}
                className={
                  active?.includes("location") ? "tw-filter-collapse" : ""
                }
                ghost={!active?.includes("location")}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <ChevronUp size={16} className="tw-text-slate-500" />
                  ) : (
                    <ChevronDown size={16} className="tw-text-slate-500" />
                  )
                }
                expandIconPosition="end"
                items={[
                  {
                    key: "location",
                    label: (
                      <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                        <MapPin size={16} className="tw-text-slate-500" />
                        Location
                      </div>
                    ),
                    children: (
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                        <div className="filterblk" id="county">
                          {showCountriesList()}
                        </div>
                        <div className="filterblk" id="state">
                          {showStatesList()}
                        </div>
                        <div className="filterblk" id="city">
                          {showCitiesList()}
                        </div>
                        <div className="filterblk" id="zipCode">
                          {showInputSearch(
                            visibleFilter,
                            "zipCode",
                            "Zip Code",
                            <Hash size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
              <Collapse
                defaultActiveKey={active}
                onChange={(val) => {
                  setActive(
                    !val?.length
                      ? [...active?.filter((d) => d !== "classification")]
                      : [...active, val[0]],
                  );
                }}
                className={
                  active?.includes("classification") ? "tw-filter-collapse" : ""
                }
                ghost={!active?.includes("classification")}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <ChevronUp size={16} className="tw-text-slate-500" />
                  ) : (
                    <ChevronDown size={16} className="tw-text-slate-500" />
                  )
                }
                expandIconPosition="end"
                items={[
                  {
                    key: "classification",
                    label: (
                      <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                        <Layers size={16} className="tw-text-slate-500" />
                        Classification
                      </div>
                    ),
                    children: (
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                        <div className="filterblk" id="zipCode">
                          {showLeadTagList(
                            visibleFilter,
                            "tags",
                            "Tags",
                            <Tag size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                        <div className="filterblk" id="notesTags">
                          {showNoteTagList(
                            visibleFilter,
                            "tags",
                            "Notes Tags",
                            <FileText size={16} className="tw-text-slate-500" />,
                          )}
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
            </div>
          )}
        </>
      );
    }
  };
  return <>{renderJsx()}</>;
};
export default AdvancedFilter;



